import React, { useState } from 'react';
import axios from 'axios';

import ImageGrid from '../components/ImageGrid';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, TextField, Checkbox, FormControlLabel, Button, Typography, Box, styled} from '@mui/material';

import RefreshIcon from '@mui/icons-material/Refresh';
import Check from '@mui/icons-material/Check';
import TheatersIcon from '@mui/icons-material/Theaters';
import AdminProductView from '../components/AdminProductView';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import CloseIcon from '@mui/icons-material/Close';

import Sidebar from '../components/Sidebar';
import ImageGalleryWithCarusel from '../components/ImageGalleryWithCarusel';
import config from '../config';
import FurnitureViewer from '../components/FurnitureViewer';


const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  height: '100%',
});

const ButtonWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  marginLeft: "0",
  marginBottom: theme.spacing(5),
  marginTop: 'auto',
  display: 'flex',
  justifyContent: 'center',
}));

const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
});

const ReviewPageHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  alignContent: 'start',
  width: '100%',
});

const CopyRender = () => {

  const navigate = useNavigate();
  const [fromProduct, setFromProduct] = useState('');
  const [toProduct, setToProduct] = useState('');
  const [fromSize, setFromSize] = useState('');
  const [toSize, setToSize] = useState('');
  const [copyVideoScenes, setCopyVideoScenes] = useState(false);
  const [copy360, setCopy360] = useState(false);
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const params = {
      from_product: fromProduct,
      to_product: toProduct,
      copy_video_scenes: copyVideoScenes,
      copy_360: copy360,
    };
    if (fromSize) {
      params.from_size = parseInt(fromSize);
    }
    if (toSize) {
      params.to_size = parseInt(toSize);
    }

    try {
      const response = await axios.post(`${config.serverUrl}/render/copy`, null, {
        params: params,
      });

      setStatus(response.data.status);
    } catch (error) {
      setStatus('Error: ' + error.message);
    }
  };

  return (
  <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
        <Container maxWidth="sm">
              <Box sx={{ mt: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                  Copy Render
                </Typography>
                <form onSubmit={handleSubmit}>
                  <TextField
                    label="From Product"
                    type="string"
                    value={fromProduct}
                    onChange={(e) => setFromProduct(e.target.value)}
                    fullWidth
                    required
                    margin="normal"
                  />
                  <TextField
                    label="To Product"
                    type="string"
                    value={toProduct}
                    onChange={(e) => setToProduct(e.target.value)}
                    fullWidth
                    required
                    margin="normal"
                  />
                  <TextField
                    label="From Size"
                    type="number"
                    value={fromSize}
                    onChange={(e) => setFromSize(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    label="To Size"
                    type="number"
                    value={toSize}
                    onChange={(e) => setToSize(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={copyVideoScenes}
                    onChange={(e) => setCopyVideoScenes(e.target.checked)}
                    color="primary"
                  />
                }
                label="Copy Video Scenes"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={copy360}
                    onChange={(e) => setCopy360(e.target.checked)}
                    color="primary"
                  />
                }
                label="Copy 360"
              />

                  <Box sx={{ mt: 2 }}>
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                      Copy
                    </Button>
                  </Box>
                </form>
                {status && (
                  <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
                    {status}
                  </Typography>
                )}
              </Box>
            </Container>
      </ContentContainer>
    </PageContainer>
  );
};

export default CopyRender;
